import { CommonModule } from '@angular/common';
import { NgModule } from '@angular/core';
import { TranslateModule } from '@ngx-translate/core';

import { AccessibilityModule } from 'app/shared/accessibility/accessibility.module';

import { CarouselSlideDirective } from './carousel-slide.directive';
import { CarouselComponent } from './carousel.component';

@NgModule({
  declarations: [
    CarouselComponent,
    CarouselSlideDirective
  ],
  exports: [
    CarouselComponent,
    CarouselSlideDirective
  ],
  imports: [
    AccessibilityModule,
    CommonModule,
    TranslateModule
  ]
})
export class CarouselModule {}
